import { render, staticRenderFns } from "./WorkersFilter.vue?vue&type=template&id=53cd39f0&"
import script from "./WorkersFilter.vue?vue&type=script&lang=js&"
export * from "./WorkersFilter.vue?vue&type=script&lang=js&"
import style0 from "./WorkersFilter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WorkersFilter.vue"
export default component.exports